import { connect } from 'react-redux';

import get from 'lodash/get';
import PropTypes from 'prop-types';
import { destroy, getFormValues } from 'redux-form';

import i18n from 'shared/lib/i18n';

import AddDeliveryComponent from './AddDeliveryComponent';

import { createDelivery } from '../Delivery/actions';
import { onModalClose, showRenderPropsModal } from '../Modal/actions';

import { validateDeliveryCreation } from '../Delivery/utils';
import { formatDeliverySelect } from '../Forms/utils';
import { openAccessPointForDelivery } from './utils';

import { deliveryFormName as form } from '../Delivery/constants';

const validate = (values) => validateDeliveryCreation(values);

const AddDeliveryContainer = (props) => (
  <AddDeliveryComponent form={form} validate={validate} {...props} />
);

const mapStateToProps = (state, ownProps) => {
  const deliveryTypeOptions = formatDeliverySelect(ownProps?.deliveryTypes);
  const deliveryNote = ownProps?.building?.deliveryNote;
  const initialValues = {
    type: deliveryTypeOptions?.[0]?.value,
  };
  const residents = get(state, 'callCenter.residents');
  const staff = get(state, 'callCenter.staff');
  const recipients = [].concat(residents, staff);
  const formValues = getFormValues(form)(state);

  return {
    ...ownProps,
    initialValues,
    recipients,
    deliveryTypeOptions,
    deliveryNote,
    formValues,
  };
};

const mapDispatchToProps = (dispatch) => ({
  onSubmit: (data, props) => {
    const building = props?.building?.id;
    const accessPoint = props?.accessPoint?.id;
    const formattedData = { ...data, building, accessPoint };
    const callback = (res) => {
      if (!res) return;
      dispatch(destroy(form));
      const { deliveries } = res.data;
      if (deliveries.length > 0) {
        openAccessPointForDelivery(dispatch, props.accessPoint, deliveries[0]);
      }
    };
    const successMessage = i18n.t('delivery.created');
    return createDelivery(dispatch, formattedData, callback, successMessage);
  },
  openModal: (props) => showRenderPropsModal(dispatch, props),
  closeModal: () => onModalClose(dispatch),
});

AddDeliveryContainer.defaultProps = {
  formValues: {},
  accessPoint: {},
  recipients: [],
  deliveryTypeOptions: [],
  deliveryNote: null,
  isCallCenter: false,
};

AddDeliveryContainer.propTypes = {
  units: PropTypes.instanceOf(Array).isRequired,
  onSubmit: PropTypes.func.isRequired,
  recipients: PropTypes.instanceOf(Array),
  deliveryTypeOptions: PropTypes.instanceOf(Array),
  isCallCenter: PropTypes.bool,
  deliveryNote: PropTypes.string,
  building: PropTypes.instanceOf(Object).isRequired,
  formValues: PropTypes.instanceOf(Object),
  accessPoint: PropTypes.instanceOf(Object),
  deliveryTypes: PropTypes.instanceOf(Array).isRequired,
  initialValues: PropTypes.instanceOf(Object).isRequired,
  openModal: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AddDeliveryContainer);
